module.exports = __webpack_public_path__ + "img/v2-redesign-sector-profile.d6e99c8c.png";